/**
 * Forgot Password — request a reset link by username/email.
 * Public route, no auth required. Always shows a generic success message
 * (the backend never reveals whether the account exists).
 */

import React, { useState, FormEvent } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

function ForgotPassword() {
  const [username, setUsername] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post("/api/auth/forgot-password", { username });
    } catch {
      // Ignore — the endpoint always responds success regardless.
    } finally {
      setLoading(false);
      setSubmitted(true);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <img src="/hoa-logo.png" alt="Horn of Africa" style={{ height: 90, display: "block", margin: "0 auto 20px" }} />
        <h2>Reset Password</h2>

        {submitted ? (
          <div style={{ backgroundColor: "#d4edda", color: "#155724", padding: "12px", borderRadius: "5px" }}>
            If an account exists for that username or email, a password reset link has been sent.
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <p style={{ color: "#666", marginBottom: "16px" }}>
              Enter your username or email and we'll send you a link to reset your password.
            </p>
            <div className="form-group">
              <label>Username or Email:</label>
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />
            </div>
            <button type="submit" disabled={loading} className="submit-btn">
              {loading ? "Sending..." : "Send Reset Link"}
            </button>
          </form>
        )}

        <div style={{ textAlign: "center", marginTop: "16px" }}>
          <Link to="/login" style={{ fontSize: "14px", color: "#15403a" }}>Back to login</Link>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
